import type * as React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';

export type DivideWithTextType = {
  /**
   * border style
   */
  borderType?: 'dashed' | 'solid';
  /**
   * forwarded className
   */
  className?: string;
  /**
   * align the text in the center
   */
  centerAlign?: boolean;
  /**
   * message to be shown
   */
  message?: string;
  /**
   * Tailwind class to change text background
   */
  textBackground?: string;
  /**
   * Tailwind class to change text color
   */
  textColor?: string;
  /**
   * Tailwind class to change text padding
   */
  textPadding?: string;
  /**
   * Tailwind class to change text size
   */
  textSize?: string;
  /**
   * Text Alignment
   */
  textAlign?: 'center' | 'end' | 'start';
  /**
   * Border color
   */
  borderColor?: string;
};

const StyledBorder = styled.div<Pick<DivideWithTextType, 'borderType'>>(
  ({ borderType }) => [
    tw`w-full border-t `,
    borderType === 'dashed' && tw`border-dashed`,
    borderType === 'solid' && tw`border-solid`,
  ]
);
const StyledText = styled.div<Pick<DivideWithTextType, 'textAlign'>>(
  ({ textAlign }) => [
    tw`relative flex flex-shrink-0`,
    textAlign === 'start' && tw`justify-start`,
    textAlign === 'center' && tw`justify-center`,
    textAlign === 'end' && tw`justify-end`,
  ]
);

export const DivideWithText: React.FunctionComponent<DivideWithTextType> = ({
  borderType = 'solid',
  centerAlign,
  children,
  className = '',
  message,
  textBackground = 'bg-white',
  textColor = 'text-gray-700',
  textSize = 'body-sm',
  textAlign = 'center',
  textPadding = 'px-2',
  borderColor = 'border-gray-500',
}) => {
  return (
    <div className={`relative flex items-center ${className}`.trim()}>
      {centerAlign ? (
        <StyledBorder borderType={borderType} className={`${borderColor}`} />
      ) : null}
      <StyledText textAlign={textAlign}>
        <span
          className={`${textPadding} ${textBackground} ${textColor} ${textSize}`}
        >
          {children || message}
        </span>
      </StyledText>
      <StyledBorder borderType={borderType} className={`${borderColor}`} />
    </div>
  );
};
